﻿import AddressViewModel from "./AddressViewModel";
import {PurchaseItemViewModel } from "./CartItemViewModel";
import PhoneNumberViewModel from "./PhoneNumberViewModel";

export default class PurchaseViewModel {
    public addressViewModel: AddressViewModel = new AddressViewModel();
    public phoneNumberViewModel: PhoneNumberViewModel = new PhoneNumberViewModel();
    public purchaseItemViewModels: PurchaseItemViewModel[] = [];
}